import { useTranslation } from "react-i18next";
import { IconLightBulb } from "../../../common/icons/IconLightBulb/IconLightBulb";
import "./IdleCustomer.scss";
import defaultContent from "../../../content/profile";
import { getDisplayName } from "../../../common/util/displayName";

type Props = {
  customerDetail?: {
    DisplayName: string;
    BusinessNatureCode: number;
    LastOrderDate: string;
  };
  dayCount: number;
};

const IdleCustomer = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const { dayCount, customerDetail } = props;

  if (customerDetail) {
    const { DisplayName, BusinessNatureCode, LastOrderDate } = customerDetail;

    const orderDate = new Date(LastOrderDate).getTime();
    const timestamp = new Date().getTime();

    const invalidDate = isNaN(orderDate) === true;
    // if difference is more then dayCount, show idleCustomer
    const noRecentOrder = timestamp - orderDate > dayCount * 24 * 60 * 60 * 1000;

    const resolvedName = getDisplayName(DisplayName, t);

    return (
      <>
        {noRecentOrder || invalidDate ? (
          <div className="leaf-idle-customer__container">
            <div className="leaf-idle-customer__container--header">
              <IconLightBulb />
              <div>
                {`${t(
                  "customerProfile.overviewTab.idleCustomer",
                  defaultContent["customerProfile"]["overviewTab"]["idleCustomer"],
                )}`}{" "}
                {BusinessNatureCode === 3 &&
                  `${t(
                    "customerProfile.overviewTab.member",
                    defaultContent["customerProfile"]["overviewTab"]["member"],
                  )}`}
                {BusinessNatureCode === 4 &&
                  `${t(
                    "customerProfile.overviewTab.customer",
                    defaultContent["customerProfile"]["overviewTab"]["customer"],
                  )}`}
              </div>
            </div>
            <div className="leaf-idle-customer__container--description">
              <span>{resolvedName}</span>
              <span className="leaf-idle-customer__container--text">
                {t(
                  "customerProfile.overviewTab.description",
                  defaultContent["customerProfile"]["overviewTab"]["description"],
                  {
                    DAY_COUNT: dayCount,
                  },
                )}
              </span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }

  return <></>;
};

export default IdleCustomer;
